// extracted by mini-css-extract-plugin
export default {"scrollTopBtn":"ScrollToTopButton_scrollTopBtn__Acx8n"};